import styled from '@emotion/styled';
import { MatchingFormat } from '@kaizenplatform/hugot-entity';
import { FormControlLabel, Radio as _Radio, RadioGroup, Typography } from '@material-ui/core';
import { createElement, FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_UNIT } from '../../../../constant/spacing';

type Props = {
  inputtedMatchingFormat?: MatchingFormat;
  availableMatchingFormats?: MatchingFormat[];
  onChangeMatchingFormat: (selected: MatchingFormat) => void;
};

const DueFormatsRadioGroup: FC<Props> = ({
  inputtedMatchingFormat,
  availableMatchingFormats,
  onChangeMatchingFormat,
}) => {
  return (
    <>
      <RadioGroup
        value={inputtedMatchingFormat}
        onChange={(e) => onChangeMatchingFormat(e.target.value as MatchingFormat)}
      >
        {availableMatchingFormats &&
          availableMatchingFormats.map(
            (mf) =>
              mf && (
                <MatchingFormatForm
                  key={mf}
                  value={mf}
                  control={<FormatRadio color="primary" />}
                  label={
                    <div>
                      <Typography variant="body1">
                        <FormattedMessage id={`matching_format.${mf}.label`} />
                      </Typography>
                      <Typography variant="caption">
                        <FormattedMessage id={`matching_format.${mf}.description`} />
                      </Typography>
                    </div>
                  }
                />
              ),
          )}
      </RadioGroup>
    </>
  );
};

const MatchingFormatForm = styled(FormControlLabel)`
  margin-top: ${SPACING_UNIT}px;
  margin-bottom: ${SPACING_UNIT}px;
`;

const FormatRadio = styled(_Radio)`
  vertical-align: top;
`;

export default DueFormatsRadioGroup;
